function checkOverflow(el)
{
  isOverflowing = false;
  if (!(el == null)) {
    if (el.scrollHeight > 1100) {
    isOverflowing = true;
    }
  }
   return isOverflowing;
}

function check_mobile() {
  if (window.screen.availWidth < 750) {
  	return true;
  } else {
  	return false;
  }
}

function heure_ouverture() {
  
  			
  
            var fetes = false;
  			var conge = false;
            var d = new Date();
			var h = d.getHours();
            var j = d.getDay();
            var txt = "";
            
            if ((d.getDate() > 20) && (d.getMonth() == 11)) {
            	fetes = true;
            }
            if ((d.getDate() < 10) && (d.getMonth() == 0)) {
            	fetes = true;
            }
  
  		console.log(opening_hour_exception);
  
  		var conge_parse = opening_hour_exception.split("-");
  
  		if (((
          (conge_parse[0] == d.getFullYear())&&
          (conge_parse[1] == d.getMonth()+1)&&
          (conge_parse[2] == d.getDate()))||opening_hour_exception == "!"
        )||opening_hour_exception=='!') {
        	conge = true;
        }
  var	o = 0;
  var c = 0;
            
            if ((j > 1)&&!fetes && !conge) {  // plus grand que 1 = mardi et + 
              
              if (j < 5) { // MARDI-JEUDI
                if (h < 18) {
				o = 10;
                c = 18;
                }
              }
              else if (j == 5) { // VENDREDI
              	if (h < 21) {
                o = 10;
                c = 21;
                  
                	
                }
              } 
              else if (j == 6) { // SAMEDI
                if (h < 16) {
                o = 10;
                c = 16;
                }
              
              }
            }
  
  if (o) {
    o_str = hour(o, opening_hour_format);
    c_str = hour(c, opening_hour_format);
    var txt = opening_text_1 + " " + o_str + " " + opening_text_2 + " " + c_str;
    }
      
  
  
  
                
            if (txt != "") {
            txt = "<a href='/pages/contact'>" + txt + "</a>";
            }
            
            document.getElementById('heure-ouverture-header').innerHTML = txt;
}

  
  function hour(h, format) {
      if (format == "ampm") {
      if (h<12) {
        str = h + "am";
      }
      else if (h==12) {
      	str = h + "pm";
      } else {
      str = (h-12) + "pm";
      }
      } else {
      str = h + "h";
      }
        return str;
  }
  
function show_more() {

	show_more_div.style.display = "none";
    product_div.style.maxHeight = "none";
}


function show_quote() {
	quote_embed.style.display = "block";
  quote_request_btn.style.display = "none";
  show_more();
}

var show_more_div = document.getElementById('show_more_div');
var quote_embed = document.getElementById('quote_embed');
var product_div = document.getElementsByClassName("show_more_product_div")[0];
var quote_request_btn = document.getElementById('quote_request_btn');

if(checkOverflow(product_div) &&(!check_mobile())) {
 show_more_div.style.display = "block";
   }


function check_agree_terms() {
var agree_check = document.getElementById('agree');
  console.log(agree_check.checked);
  console.log('checked agree');
  if(agree_check.checked) {
  document.getElementById('cart_main_submit_button').disabled = false;
    
    document.getElementById('additional-checkout-button').style.visibility = 'inherit';
    
    document.getElementById('term-condition-alert-container').hidden = true;
    document.getElementById('term-condition-alert').hidden = true;
    
   
    
    
  } else {
  document.getElementById('cart_main_submit_button').disabled = true;
    document.getElementById('additional-checkout-button').style.visibility = 'hidden';
    
        document.getElementById('term-condition-alert-container').hidden =false;
    document.getElementById('term-condition-alert').hidden = false;
    
  }

}


heure_ouverture();

document.addEventListener('DOMContentLoaded', (event) => {
  
check_agree_terms();
})

